export const stateKey = 'state'

export const RequestStatus = {
  Idle: 'idle',
  Pending: 'pending',
  Succeeded: 'succeeded',
  Failed: 'failed'
}
